import axios from 'axios';
import ROUTES from '../api/routes';
import { TOKEN_CLIENT_LOCAL_STORAGE_NAME } from '../constants/constants';

export default function getBenchmarkEUI() {
  return (_, getStore) => {
    const { accessToken } = JSON.parse(localStorage.getItem(TOKEN_CLIENT_LOCAL_STORAGE_NAME)) || {};
    const { organizationId } = getStore().data;

    return axios.get(
      `${ROUTES.GET_BUILDINGS}/${organizationId}/benchmark-information/energy-usage-index`,
      {
        headers: {
          accept: 'application/json',
          Authorization: accessToken,
        },
      },
    )
      .then(({ data }) => data)
      .catch((err) => err);
  };
}
